import { useMemo } from "react";
import { FirestoreOrganisationLanguage } from "reedy-data/api";
import { useTranslation } from "react-i18next";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "components/ui/select";

export const LanguageSettingsLanguageDropdown = ({
  value,
  onChange,
  className,
  disabled,
}: {
  value?: FirestoreOrganisationLanguage;
  onChange?: (value: FirestoreOrganisationLanguage) => void;
  className?: string;
  disabled?: boolean;
}) => {
  const { t } = useTranslation("settings");

  const options: { label: string; value: FirestoreOrganisationLanguage }[] =
    useMemo(
      () => [
        {
          value: FirestoreOrganisationLanguage.DE_DE,
          label: t("organisation.settings.language.options.DE_DE"),
        },
        {
          value: FirestoreOrganisationLanguage.EN_US,
          label: t("organisation.settings.language.options.EN_US"),
        },
        {
          value: FirestoreOrganisationLanguage.EN_GB,
          label: t("organisation.settings.language.options.EN_GB"),
        },
      ],
      [t],
    );

  return (
    <div className={className}>
      <Select value={value} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger aria-label={t("organisation.settings.language.title")}>
          <SelectValue
            placeholder={t("organisation.settings.language.placeholder")}
          />
        </SelectTrigger>
        <SelectContent align="end">
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
